import { useEffect } from "react";
import { useRawTable } from "../../hooks";
import moment from "moment";

export default function Module_ElderlyHealth_CaseScaleTotalScoreAll({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
  exportData = [],
  totalRecord,
  callMainAPI,
  isResetPage,
}) {
  const { setTbData, setTbFirstIndex, renderTable } = useRawTable({
    setting: moduleData,
    nullTransfer: "-",
    subTitleBgColor: "elderlytitle1",
  });

  useEffect(() => {
    if (!isResetPage) return;

    setTbFirstIndex(0);
  }, [isResetPage]);

  useEffect(() => {
    if (!apiData) return;

    const formatDetail = (data) => {
      if (!data) return null;

      return data.map((item) => ({
        ...item,
        篩檢日期: item["篩檢日期"]
          ? moment(item["篩檢日期"]).format("YYYY-MM-DD")
          : "-",
        IADL_count:
          ([8304, 8305].includes(item.IADL1) ? 1 : 0) +
          ([8309, 8310].includes(item.IADL2) ? 1 : 0) +
          ([8314].includes(item.IADL3) ? 1 : 0) +
          ([8318, 8319].includes(item.IADL4) ? 1 : 0) +
          ([8322].includes(item.IADL5) ? 1 : 0),
      }));
    };

    setTbData({
      raw: formatDetail(apiData ?? []),
      format: null,
      export: formatDetail(apiData ?? []),
      totalRecord: apiData.length,
    });
  }, [apiData, exportData]);

  return (
    <>
      {renderTable({
        moduleTitle: moduleData.label,
        isLazy: true,
        isPaginator: true,
        callMainAPI: null,
      })}
    </>
  );
}
